// extracted by mini-css-extract-plugin
export default {"iconBtn":"AuthClearAppDataButton_iconBtn__0WZgS","iconBtnBusy":"AuthClearAppDataButton_iconBtnBusy__OZZg3","clearAppDataSpin":"AuthClearAppDataButton_clearAppDataSpin__pJMiG"};